module.exports = __webpack_public_path__ + "img/dominant_back2.0361ec84.png";